<template>
<div>
  <div class="loading-position"><img src="./images/img_loading.gif" alt="" v-show="isLoading"></div>
  <!--Start 예약신청-->
  <div class="mask_contents-wrap with_floting" v-show="step == 0">
    <h1 class="title_type-a">엣모스피어 스카이 <span class="m_block">미세먼지 마스크 KF94 (30매)</span></h1>
    <p class="mask-limit">마스크 공급에 제한이 있어 <span class="m_block">대형과 소형 중 1개만 예약 가능합니다.</span></p>
    <div class="list_mask">
      <div class="list-item">
        <div class="choice-area">
          <span class="form_element-radio no_label">
            <input type="radio" id="choice2" name="choice" value="qty1" v-model="qty">
            <label for="choice2" class="sp_chk focus">선택</label>
          </span>
        </div>
        <div class="img_product"><img src="./images/mask_big.jpg" alt="" @click="qty='qty1'"></div>
        <dl class="product_info">
          <dt class="txt_product">대형 (295882K)</dt>
          <dd class="txt_price-content"><span class="price_value">26,000</span>원</dd>
        </dl>
        <!--<dl class="product_info count">
          <dt class="txt_product">수량</dt>
          <dd class="txt_price-content"><span class="price_value">1</span>개</dd>
        </dl>
        <p class="txt_reservation-info">* 마스크 공급에 제한이 있어 대형 1개만 예약하실 수 있습니다.</p>-->
        <!--<p class="txt_amount">수량 (최대 1개까지 예약 가능)</p>
        <div class="product_select">
                  <span class="form_select-default">
                      <select class="form_select">
                          <option>0</option>
                          <option>1</option>
                      </select>
                  </span>
        </div>-->
      </div>
      <div class="list-item">
        <div class="choice-area">
          <span class="form_element-radio no_label">
            <input type="radio" id="choice1" name="choice" value="qty2" v-model="qty">
            <label for="choice1" class="sp_chk focus">선택</label>
          </span>
        </div>
        <div class="img_product"><img src="./images/mask_small.jpg" alt="" @click="qty='qty2'"></div>
        <dl class="product_info">
          <dt class="txt_product">소형 (295883K)</dt>
          <dd class="txt_price-content"><span class="price_value">26,000</span>원</dd>
        </dl>
        <!--<dl class="product_info count">
          <dt class="txt_product">수량</dt>
          <dd class="txt_price-content"><span class="price_value">1</span>개</dd>
        </dl>
        <p class="txt_reservation-info">* 마스크 공급에 제한이 있어 대형 1개만 예약하실 수 있습니다.</p>-->
        <!--<p class="txt_amount">수량 (최대 1개까지 예약 가능)</p>
              <div class="product_select">
                  <span class="form_select-default">
                      <select class="form_select">
                          <option>0</option>
                          <option>1</option>
                      </select>
                  </span>
              </div>-->
      </div>
    </div>
    <div class="reservation-area">
      <h2 class="title_type-b">예약자 정보 입력</h2>
      <div>
        <div class="new-join-wrap">
          <div class="ipt_area">
            <label for="ko_abo" class="form_label">ABO 번호</label>
            <input type="tel" class="form_ipt" id="ko_abo" v-model="abo_no" v-mask="'###########'">
          </div>
          <div class="ipt_area">
            <label for="ko_name" class="form_label">이름</label>
            <input type="text" class="form_ipt" id="ko_name" :value="name" @input="maxlengthName">
          </div>
          <div class="ipt_area">
            <label for="phone_number" class="form_label">휴대폰 번호(-없이 입력)</label>
            <input type="tel" class="form_ipt check_hyphen" id="phone_number" v-model="phone" v-mask="'###########'">
          </div>
        </div>
      </div>
      <h2 class="title_type-b">약관 및 개인정보 동의</h2>
      <div class="box_terms">
        <div class="terms-item">
          <div class="txt_terms">
              <span class="form_element-checkbox no_label">
                <input type="checkbox" id="agree1" v-model="terms1">
                <label for="agree1" class="sp_chk focus">agree</label>
              </span>
            <label for="agree1" class="sp_chk focus">&nbsp;[필수] 개인정보 수집/이용 동의서</label>
          </div>
          <div class="terms_agree">
            <button type="button" class="link_allview agree_pop01">전체보기</button>
          </div>
        </div>
        <div class="terms-item">
          <div class="txt_terms">
            <span class="form_element-checkbox no_label">
              <input type="checkbox" id="agree2" v-model="terms2">
              <label for="agree2" class="sp_chk focus">agree</label>
            </span>
            <label for="agree2" class="sp_chk focus">&nbsp;[필수] 이용약관</label>
          </div>
          <div class="terms_agree">
            <button type="button" class="link_allview agree_pop02">전체보기</button>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-area">
      <button type="button" class="btn_type-a" @click="submit" :disabled="clicked">예약 신청</button>
    </div>
    <!-- S : 개인정보 수집/이용 동의서 -->
    <div class="agree_content-a layer_agree">
      <div class="box_agree">
        <h1 class="title_agree">[필수] 개인정보 수집/이용 동의서</h1>
        <div class="agree_contents">
          <p class="txt_agree-a">한국암웨이㈜는 엣모스피어 스카이 미세먼지마스크 구매 예약 신청을 위하여 다음과 같이 귀하의 개인정보를 수집, 이용합니다.</p>
          <dl class="agree_data">
            <dt class="txt_sub-title">개인정보의 수집 및 이용 목적</dt>
            <dd class="txt_content">신청자 본인 식별 및 구매권한 부여</dd>
            <dd class="txt_content">신청자 구매 가능일 및 구매 가능한 링크 관련 고지사항 전달</dd>
          </dl>
          <dl class="agree_data">
            <dt class="txt_sub-title">수집하는 개인정보의 항목</dt>
            <dd class="txt_content">ABO 번호, 성명, 휴대폰 번호</dd>
          </dl>
          <dl class="agree_data">
            <dt class="txt_sub-title">개인정보의 보유 및 이용기간</dt>
            <dd class="txt_content">개인정보 수집 후 3개월 간 보유</dd>
          </dl>
          <p class="txt_agree-b">※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 엣모스피어 스카이 미세먼지마스크 구매예약 신청이 불가합니다.</p>
          <p class="txt_agree-c">본인은 위 개인정보 수집 ∙ 이용에 동의합니다.</p>
        </div>
        <button type="button" class="agree_layer_close">닫기</button>
      </div>
    </div>
    <!-- E : 개인정보 수집/이용 동의서 -->

    <!-- S : 이용약관 -->
    <div class="agree_content-b layer_agree">
      <div class="box_agree">
        <h1 class="title_agree">[필수] 이용약관</h1>
        <div class="agree_contents">
          <p class="txt_agree-b">1. 목적</p>
          <p class="txt_agree-c">이 약관은 한국암웨이에서 제공하는 엣모스피어 스카이 미세먼지마스크 구매 예약 서비스 (이하 “서비스”라 한다)를 이용함에 있어 Amway와 사용자의 권리와 의무 및 책임사항을 규정함을 목적으로 한다.</p>
          <p class="txt_agree-b">2. 서비스 정의</p>
          <ul class="list_agree">
            <li class="list-item">1) Amway는 사용자에게 엣모스피어 스카이 미세먼지마스크 구매 예약을 할 수 있도록 www.amway.co.kr 사이트 및 Amway 앱에서 신청 화면을 제공한다.</li>
            <li class="list-item">2) 사용자는 구매 예약 신청 시 구매할 수량과 개인정보(ABO번호, 성명, 휴대폰 번호)를 신청 화면에 입력한다.</li>
            <li class="list-item">3) 사용자가 구매 예약 신청 완료 후, Amway는 수집된 사용자 정보와 Amway에서 보유하고 있는 회원정보를 비교하여 구매 가능한 사용자를 식별한다.</li>
            <li class="list-item">4) Amway는 Amway 회원으로 식별된 사용자에게 구매 가능한 날짜 및 구매링크에 대한 안내를 SMS 및 Amway 사이트 맞춤메시지를 통해 제공한다.</li>
            <li class="list-item">5) 사용자는 구매링크 접속했을 때 구매 예약했던 수량의 제품을 확인할 수 있으며 Amway 사이트 주문 절차에 따라 구매할 수 있다.</li>
            <li class="list-item">6) 사용자는 구매링크를 받은 후 3일 이내 구매하지 않는 경우, 구매 가능 권한이 소멸되며 구매할 수 없다.</li>
            <li class="list-item">7) 사용자가 구매한 제품을 환불하고자 하는 경우 Amway의 환불 정책에 따라 대금 환급을 제공한다.</li>
            <li class="list-item">8) 사용자의 구매한 제품 반품 정책은 Amway의 반품 정책을 따른다.</li>
          </ul>
        </div>
        <button type="button" class="agree_layer_close">닫기</button>
      </div>
    </div>
    <!-- E : 이용약관 -->

  </div>
  <!--End 예약신청-->

  <!--Start 예약완료-->
  <div class="mask_contents-wrap" v-show="step == 1">
    <p class="txt_complete"><i class="blt_complete"></i>예약이 완료되었습니다.</p>
    <div class="reservation-info">
      <h2 class="title_type-b">예약 정보</h2>
      <dl class="reservation_data">
        <dt class="reservation_title">예약 코드</dt>
        <dd class="reservation_value">{{ c_seq }}</dd>
      </dl>
      <dl class="reservation_data">
        <dt class="reservation_title">예약일</dt>
        <dd class="reservation_value">{{ c_date }}</dd>
      </dl>
      <dl class="reservation_data">
        <dt class="reservation_title">ABO 번호</dt>
        <dd class="reservation_value">{{ c_abo_no }}</dd>
      </dl>
      <dl class="reservation_data">
        <dt class="reservation_title">이름</dt>
        <dd class="reservation_value">{{ c_name }}</dd>
      </dl>
      <dl class="reservation_data">
        <dt class="reservation_title">휴대폰 번호</dt>
        <dd class="reservation_value">{{ c_phone }}</dd>
      </dl>
    </div>
    <div class="reservation_product">
      <div class="product_img" v-show="c_qty1 == '1'"><img src="./images/mask_big.jpg" alt=""></div>
      <div class="product_img" v-show="c_qty2 == '1'"><img src="./images/mask_small.jpg" alt=""></div>
      <div class="product_data">
        <p class="product_name">엣모스피어 스카이 미세먼지 마스크 KF94 {{c_qty1 == '1'?'대형':'소형'}} (30매)</p>
        <p class="product_sku">SKU : {{c_qty1 == '1'?'295882K':'295883K'}}</p>
        <p class="product_price"><span class="product_value">26,000</span>원 / <span class="product_value">1</span>개</p>
      </div>
    </div>
    <div class="banner-area">
      <img src="./images/banner.png" alt="엣모피어스 스카이 좋은 공기만으로 생활은 달라질 수 있습니다.">
    </div>
  </div>
  <!--End 예약완료-->
  <button type="button" class="layer_close" @click='redirectHome'>닫기</button>
</div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import axios from 'axios'
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

export default {
  name: 'atmosphere-mask-apply',
  data () {
    return {
      step: 0,
      options: [
        { text: '0개', value: '0' },
        { text: '1개', value: '1' }
      ],
      seq: '',
      date: '',
      abo_no: '',
      name: '',
      phone: '',
      qty: 'qty1',
      qty1: '0',
      qty2: '0',
      terms1: false,
      terms2: false,
      isLoading: false,
      isStartSubmit: false,
      isStartConfirm: false,
      isOpen: '',
      c_seq: '',
      c_date: '',
      c_abo_no: '',
      c_name: '',
      c_phone: '',
      c_qty1: '0',
      c_qty2: '0',
      clicked: false
    }
  },
  methods: {
    updateNow() {
      this.isOpen = new Date('02/28/2020 09:00:00') > new Date()
      this.scheduleUpdateNow();
    },
    scheduleUpdateNow() {
      setTimeout(this.updateNow, 1000);
    },
    init () {
      this.seq = ''
      this.date = ''
      this.abo_no = ''
      this.name = ''
      this.phone = ''
      this.qty = ''
      this.qty1 = '0'
      this.qty2 = '0'
      this.terms1 = false
      this.terms2 = false
      this.isStartSubmit = false
      this.isStartConfirm = false
    },
    maxlengthName (event) {

      const value = event.target.value
      if (String(value).length <= 50) {
        this.name = value.trim()
      }
      this.$forceUpdate()
    },
    validExcptABO () {
      if (this.qty1 !== '0') {
        axios.post(process.env.AWS_GATEWAY_URL + '/mask/except', {
          abo_no: this.abo_no
        }, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(response => {
          console.log('response : ', JSON.stringify(response, null, 2))
          if (response.status === 200) {
            if (response.data.result === 'DUP') {
              alert('이미 마스크를 구매하셔서 선택할수 없습니다.')
              this.qty1 = '0'
            }
          } else {
            alert('죄송합니다.예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
          }
        }).catch(error => {
          console.log('error : ', error)
          alert('죄송합니다.예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
        })
      }
    },
    selectQty () {
      this.qty1 = '0'
      this.qty2 = '0'
      if (this.qty === 'qty1') {
        this.qty1 = '1'
      } else if (this.qty === 'qty2') {
        this.qty2 = '1'
      }
    },
    valid () {
      if (!this.qty) {
        alert('제품을 선택하세요.')
        return false
      } else if (!this.abo_no) {
        alert('ABO번호를 입력하세요.')
        return false
      } else if (this.abo_no.length < 5) {
        alert('ABO번호를 5자리 이상으로 입력해 주세요.')
        return false
      } else if (!this.name) {
        alert('이름을 입력하세요.')
        return false
      } else if (!this.phone) {
        alert('휴대폰번호를 입력하세요.')
        return false
      } else if (this.phone.length < 10) {
        alert('휴대폰번호를 10자리 이상으로 입력해 주세요.')
        return false
      } else if (!this.terms1) {
        alert('개인정보 수집/이용 동의서에 동의해주세요.')
        return false
      } else if (!this.terms2) {
        alert('이용약관에 동의해주세요.')
        return false
      }
      return true
    },
    submit () {
      if(this.qty === 'qty1'){
        utag.link({
          event_name: 'cart_addition',
          product_id: ['295882K'],
          product_name: ['엣모스피어 스카이 미세먼지 마스크 KF94 (30매) 대형'],
          product_units: ['1'],
          product_unitPrice:['26000'],
          product_pointValue:['7330'],
          product_brand:['엣모스피어'],
          cart_addType: 'mask reserve'
        })
      } else if(this.qty === 'qty2'){
        utag.link({
          event_name: 'cart_addition',
          product_id: ['295883K'],
          product_name: ['엣모스피어 스카이 미세먼지 마스크 KF94 (30매) 소형'],
          product_units: ['1'],
          product_unitPrice:['26000'],
          product_pointValue:['7330'],
          product_brand:['엣모스피어'],
          cart_addType: 'mask reserve'
        })
      }

      if(this.clicked){
        return
      }

      this.clicked = true

      setTimeout(function(){ this.clicked = false }.bind(this),1000)

      if(!this.isOpen){
        alert('엣모스피어 스카이 미세먼지 마스크 예약이 종료되었습니다.')
        return
      }
      this.isStartSubmit = true
      this.selectQty()
      if (this.valid()) {
        this.isLoading = true
        setTimeout(() => { this.isLoading = false }, 1000)
        axios.post(process.env.AWS_GATEWAY_URL + '/mask', {
          abo_no: this.abo_no,
          name: this.name,
          phone: this.phone,
          qty1: this.qty1,
          qty2: this.qty2
        }, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(response => {
          console.log('response : ', JSON.stringify(response, null, 2))
          if (response.status === 200) {
            if (response.data === 'DUP') {
              alert('이미 예약을 완료하셨습니다.\n예약은 ABO번호당 한 번만 가능합니다.\n예약조회는 추후 확인 가능합니다.')
            } else if (response.data === 'QTY_Limit' || response.data === 'QTY1_Limit' || response.data === 'QTY2_Limit') {
              alert('예약 주문수량이 소진 되었습니다.')
            } else if (response.data === 'PASS') {
              this.isStartSubmit = false
              return this.gotoComplete()
            } else if (response.data === 'TIME') {
              alert('엣모스피어 스카이 미세먼지 마스크 예약은 2월 28일(금) 9시부터 가능합니다.')
            } else if (response.data === 'ERROR') {
              alert('죄송합니다.예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
            } else {
              alert('죄송합니다.예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
            }
          } else {
            alert('죄송합니다.예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
          }
          this.isStartSubmit = false
        }).catch(error => {
          console.log('error : ', error)
          alert('죄송합니다.예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
          this.isStartSubmit = false
        })
      }
      this.isStartSubmit = false
    },
    gotoComplete () {
      this.confirm()
    },
    confirm () {
      if(this.abo_no && this.name && this.phone){
        this.isStartConfirm = true
        axios.post(process.env.AWS_GATEWAY_URL + '/masks', {
          abo_no: this.abo_no,
          name: this.name,
          phone: this.phone
        }, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(response => {
          console.log('response : ', JSON.stringify(response, null, 2))
          if (response.status === 200) {
            if (response.data.ABO_NO === 'E') {
              alert('죄송합니다.예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
            } else if (response.data === 'ERROR') {
              alert('죄송합니다.예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
            } else {
              this.c_seq = btoa(response.data.ABO_NO)
              this.c_date = response.data.Date
              this.c_abo_no = response.data.ABO_NO
              this.c_name = response.data.Name
              this.c_phone = response.data.Phone
              this.c_qty1 = response.data.QTY1
              this.c_qty2 = response.data.QTY2
              this.step = 1
              this.init()
            }
          } else {
            alert('죄송합니다.예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
          }
          this.isStartConfirm = false
        }).catch(error => {
          console.log('error : ', error)
          alert('죄송합니다.예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
          this.isStartConfirm = false
        })
        this.isStartConfirm = false
      }
    },
    redirectHome() {
      var url = 'https://www.amway.co.kr'
      window.open(url, "_self");
    }
  },
  created: function () {
    this.scheduleUpdateNow()
    document.title = '엣모스피어 마스크 예약'

    var utag_data = {
      site_type : 'responsive', //  desktop /mobile
      site_country : 'kr', //  kr 고정
      site_language : 'ko', //  ko 고정
      site_subGroup : 'korea', //  korea 고정
      site_subRegion : 'korea', //  korea 고정
      site_region : 'apac',//  apac 고정
      site_webProperty : 'ecm', //  ecm 고정
      site_currencyCode : 'krw', //
      page_section : '미세먼지마스크',
      page_category : '예약', // 공백없이 입력
      page_subcategory : '', // 
      page_detail : '미세먼지마스크예약',
      visitor_imcID: '18000007480003',
      visitor_pinNumber: 'platinum', //this can be a descriptive value (e.g., platinum, silver_producer, diamond, etc.)
      visitor_userProfile: 'abo'
    }
  },
  mounted: function () {
    window.addEventListener('DOMContentLoaded', function () {
      $('.form_ipt').not('.ipt_area_change .form_ipt').each(function() {
        var thisInput = $(this)
        var paDiv = thisInput.parent()
        thisInput.on('focus focusout', function (e) {
          if (e.type === 'focus') {
            if (!paDiv.hasClass('on')) {
              paDiv.addClass('on')
            }
          } else if (e.type === 'focusout') {
            if (thisInput.val() == '') {
              paDiv.removeClass('on')
            }
          }
        })
      })
    })

    $(function() {
      $('.agree_pop01').click(function(event) {
        $('html').addClass('scroll_off');
        $('.agree_content-a').addClass('active');
              $( '.layer_close', parent.document ).attr( 'disabled', true );
      });
      $('.agree_pop02').click(function(event) {
        $('html').addClass('scroll_off');
        $('.agree_content-b').addClass('active');
              $( '.layer_close', parent.document ).attr( 'disabled', true );
      });
      $('.agree_layer_close').click(function(event) {
        $('html').removeClass('scroll_off');
        $('.layer_agree').removeClass('active');
              $( '.layer_close', parent.document ).attr( 'disabled', false );
      });
    })

    $(function(a,b,c,d){
        //a='//tags.tiqcdn.com/utag/amway/kr-hybris/dev/utag.js';// 개발/QA환경인 경우
        a='//tags.tiqcdn.com/utag/amway/kr-hybris/prod/utag.js';// Production 환경인 경우
        b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
        a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
    });

		if (typeof NetFunnel !== 'undefined' && typeof NetFunnel_Complete !== 'undefined') {
      console.log('cookie_id : ', NetFunnel.TS_COOKIE_ID);
      //NetFunnel_Complete({cookie_id : NetFunnel.TS_COOKIE_ID});
		} else {
      console.log('NetFunnel : ', NetFunnel);
      console.log('NetFunnel_Complete : ', NetFunnel_Complete);
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR:300,400,500,700&subset=korean');
@import './css/mask.css';
</style>



// WEBPACK FOOTER //
// src/views/atmosphere-mask/apply.vue